export default __webpack_public_path__ + "static/media/circle-icon2.c40f8a90.png";